import { Result } from '@empathy/search-types';
import { StorageService } from '@empathy/storage-service';
import { container } from '../../../container';
import { DEPENDENCIES, STORAGE } from '../../../container/dependencies.const';
import { EmpathyXConfig } from '../../../models';
import { Dictionary } from '../../../utils';
import { GETTERS_KEYS } from '../../store.const';
import { TRACKING_ACTIONS_KEYS } from '../tracking.const';
import { TrackingAction, TrackingContext } from '../tracking.interfaces';

export class CheckoutAction implements TrackingAction {

  private localStorageService: StorageService;
  private sessionStorageService: StorageService;

  actions = {
    [TRACKING_ACTIONS_KEYS.addResultToLocalStorageCheckout]: ({ rootGetters }: TrackingContext, result?: Result) => {
      this.initDependencies();
      const { tracking }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
      const checkout = this.localStorageService.getItem<Dictionary<Result>>(tracking.checkout.storage.key) || {};
      result = result || this.sessionStorageService.getItem<Result>(tracking.addToCart.storage.result);

      if (result) {
        checkout[result.id] = result;
        this.localStorageService.setItem(tracking.checkout.storage.key, checkout, tracking.checkout.storage.ttlInMs);
      }
    },
    [TRACKING_ACTIONS_KEYS.removeLocalStorageCheckout]: ({ rootGetters }: TrackingContext) => {
      this.initDependencies();
      const { tracking }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
      this.localStorageService.removeItem(tracking.checkout.storage.key);
    }
  };

  private initDependencies() {
    this.localStorageService = this.localStorageService
      || container.getNamed<StorageService>(DEPENDENCIES.StorageService, STORAGE.Local);
    this.sessionStorageService = this.sessionStorageService
      || container.getNamed<StorageService>(DEPENDENCIES.StorageService, STORAGE.Session);
  }
}
